import { render, staticRenderFns } from "./AgreementContent.vue?vue&type=template&id=3809d352&scoped=true&"
import script from "./AgreementContent.vue?vue&type=script&lang=js&"
export * from "./AgreementContent.vue?vue&type=script&lang=js&"
import style0 from "./AgreementContent.vue?vue&type=style&index=0&id=3809d352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809d352",
  null
  
)

export default component.exports